import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useMutationDeleteStaff({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (staffId: string) => await api.staffApi.delete(staffId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: staffQueryKeys.all() }),
  });
}
